import { primaryColor, webFont } from "../../config/theme";

export default {
  headingText: {
    fontSize: "30px",
    fontFamily: webFont,
    fontWeight: 500,
    margin: '0 0 14px',
  },
  subHeadingText: {
    fontSize: "15px",
    fontFamily: webFont
  },
  userName: {
    fontSize: "20px",
    fontFamily: webFont,
    fontWeight: 500
  },
  userNameSM: {
    fontSize: "20px",
    fontFamily: webFont,
    fontWeight: 500,
    width: 150,
  },
  userDistance: {
    fontSize: "14px",
    fontFamily: webFont,
    fontWeight: 500,
    color: "#979797"
  },
  removeMargin: {
    margin: 0
  },
  avatar: {
    width: "56px",
    height: "56px"
  },
  price: {
    fontSize: "24px",
    fontFamily: webFont,
    fontWeight: 500,
    color: primaryColor,
    margin: 0,
  },
  priceSM: {
    fontSize: "24px",
    fontFamily: webFont,
    fontWeight: 500,
    color: primaryColor,
    margin: 0,
    marginLeft: 85
  },
  description: {
    fontSize: "15px",
    color: "#9c9c9c",
    fontFamily: webFont,
    margin: '30px 0 10px',
  },
  label: {
    fontSize: "15px",
    color: "#000000",
    fontFamily: webFont
  },
  listHeading: {
    fontSize: "15px",
    color: "#000000",
    fontFamily: webFont,
    fontWeight: 500
  },
  value: {
    fontSize: "15px",
    color: "#000000",
    fontFamily: webFont,
    fontWeight: 300
  },
  valueCheck: {
    textAlign: 'right',
    fontSize: "15px",
    color: "#000000",
    fontFamily: webFont,
  },
  listItemStyle: {
    padding: 0,
    display: "flex",
    justifyContent: "space-between"
  },
  nextButton: {
    width: 204,
    height: 49,
    borderRadius: "45.5px",
    fontSize: 18,
    color: "white",
    textTransform: "none",
    fontFamily: webFont
  },
  confirmButton: {
    width: 220,
    height: 44,
    borderRadius: 22,
    fontSize: 18,
    color: "white",
    textTransform: "none",
    fontFamily: webFont,
    boxShadow: 'none',
    fontWeight: 'normal'
  },
  declineButton: {
    width: 220,
    height: 44,
    borderRadius: 22,
    fontSize: 18,
    color: primaryColor,
    textTransform: "none",
    fontFamily: webFont
  },
  reasonText: {
    fontSize: 20,
    fontWeight: 500,
    fontFamily: webFont,
    margin: "35px 0px 6px",
  },
  viewDetailsButton: {
    height: 32,
    width: 154,
    textTransform: "none",
    borderRadius: 18,
    opacity: 0.7,
    border: "1px solid #ff8000",
    fontSize: 15,
    color: "#fff",
    fontFamily: webFont,
    lineHeight: "10px",
    backgroundColor: '#ff8000'
  },
  sendButtonStyles: {
    height: 40,
    width: 160,
    textTransform: "none",
    borderRadius: 18,
    opacity: 0.7,
    border: "1px solid #ff8000",
    fontSize: 16,
    color: "#fff",
    fontFamily: webFont,
    lineHeight: "22px",
    backgroundColor: '#ff8000'
  },
};
